import React from 'react'
import ContentLoader from 'react-content-loader'

import styles from './ItemLoader.module.scss'

export type ItemLoaderProps = Omit<React.ComponentProps<typeof ContentLoader>, 'width' | 'height'> & {
	width?: number
	height?: number
}

export const ItemLoader = ({ width = 308, height = 459, className, ...props }: ItemLoaderProps): JSX.Element => {
	const itemLoaderClassName = [styles.itemLoader, className].filter(Boolean).join(' ')

	return (
		<ContentLoader
			className={itemLoaderClassName}
			speed={2}
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			backgroundColor="#f3f3f3"
			foregroundColor="#ecebeb"
			{...props}>
			<rect x="18" y="36" rx="8" ry="8" width={width * 0.5} height="25" />
			<rect x={width * 0.66} y="36" rx="8" ry="8" width={width * 0.19} height="25" />
			<rect x="15" y="88" rx="14" ry="14" width={width * 0.8} height="35" />
			<rect x="18" y="141" rx="4" ry="4" width={width * 0.8} height={height * 0.45} />
			<rect x="19" y={height - 39} rx="14" ry="14" width={width * 0.8} height="35" />
			<rect x="22" y={height - 71} rx="8" ry="8" width={width * 0.42} height="25" />
			<rect x={width * 0.55} y={height - 71} rx="8" ry="8" width={width * 0.3} height="25" />
		</ContentLoader>
	)
}
